module.exports = __webpack_public_path__ + "img/photo-0097.e56fd19d.jpg";